export default __webpack_public_path__ + "static/media/solutions-mobile.f63c72e1.jpg";